import { Spinner } from "@chakra-ui/react";

interface ParrotSpinnerProps {
  size?: string;
}

export default function ParrotSpinner({ size = "xl" }: ParrotSpinnerProps) {
  return (
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="var(--color-grey-light)"
      color="var(--color-blue)"
      size={size}
    />
  );
}
